import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TruncatePipe } from './whatsapp-pipe/truncate.pipe';
import { WhatsappChatRoutingModule } from './whatsapp-chat-routing.module';
import { WhatsappChatComponent } from './whatsapp-chat.component';
import { WhatsappChatDetailsComponent } from './whatsapp-chat-details/whatsapp-chat-details.component';
import { FormsModule } from '@angular/forms';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatMenuModule } from '@angular/material/menu';
import { MatIconModule } from '@angular/material/icon';
import { OrdinalDatePipe } from './whatsapp-pipe/ordinalDate.pipe';
import { TimeAgoDetailedPipe } from './whatsapp-pipe/timeAgoDetails.pipe';
import { CommonImagesModule } from '../../common-images/common-images.module';
import { FileUploadModule } from 'ng2-file-upload';
import { CommonFileUploadModule } from 'src/app/global/common-file-upload/common-file-upload.module';
import { MatDialogModule } from '@angular/material/dialog';
import { CustomFlexLayoutModule } from 'src/app/shared/flex-layout/custom-flex-layout.module';
import { MatButtonModule } from '@angular/material/button';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { SharedModule } from 'src/app/shared/shared.module';
import { WhatsAppAssigneUserComponent } from './whats-app-assigne-user/whats-app-assigne-user.component';
import { ImageZoomComponent } from './image-zoom/image-zoom.component';
import { LoaderModule } from '../../loader/loader.module';
import { HomepageModule } from '../../system/homepage/homepage.module';
import { WhatsappcontactModule } from '../whatsappcontact/whatsappcontact.module';
import { MediaPickerDialogComponent } from './media-picker-dialog/media-picker-dialog.component';
import { WhatsappImageModule } from '../../whatsapp-image/whatsapp-image.module';
import { WhatsappVideoModule } from '../whatsappResource/whatsapp-video/whatsapp-video.module';
import { WhatsappPdfModule } from '../whatsappResource/whatsapp-pdf/whatsapp-pdf.module';
import { WhatsappAudioTwoComponent } from './whatsapp-audio-two/whatsapp-audio-two.component'; 
import { PickerModule } from '@ctrl/ngx-emoji-mart';
import { TemplatePreviewModule } from '../template-screen/template-preview/template-preview.module';

@NgModule({
  declarations: [
    WhatsappChatComponent,
    WhatsappChatDetailsComponent,
    TruncatePipe,
    OrdinalDatePipe,
    TimeAgoDetailedPipe,
    WhatsAppAssigneUserComponent,
    ImageZoomComponent,
    MediaPickerDialogComponent,
    WhatsappAudioTwoComponent
  ],
  imports: [
    CommonModule,
    WhatsappChatRoutingModule,
    CommonImagesModule,
    FileUploadModule,
    CommonFileUploadModule,
    TemplatePreviewModule,
    MatDialogModule,
    CustomFlexLayoutModule,
    SharedModule,
    LoaderModule,
    NgxMatSelectSearchModule,
    WhatsappPdfModule,
    WhatsappImageModule,
    WhatsappVideoModule,
    PickerModule
  ], 
  exports: [WhatsappChatDetailsComponent, WhatsappChatComponent, TimeAgoDetailedPipe,TruncatePipe ,MediaPickerDialogComponent, WhatsappAudioTwoComponent, OrdinalDatePipe , ImageZoomComponent, WhatsAppAssigneUserComponent]
})
export class WhatsappChatModule { }
